import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

import { HomeAllFeatures } from "@/components/new-home/all-features/home-all-features";
import { FlowHeader } from "@/components/ui/flow-header/flow-header";
import { Page } from "@/components/ui/layout/page/page";
import { RoundedLayout } from "@/components/ui/layout/rounded-layout";

const AllFeaturesPage = (): JSX.Element => {
  return (
    <RoundedLayout contentClassName="bg-neutral-50">
      <FlowHeader>
        <FlowHeader.Actions>
          <FlowHeader.BackButton />
          <FlowHeader.Title title="Ver tudo" />
        </FlowHeader.Actions>
      </FlowHeader>
      <Page className="px-0 pt-0 max-w-none md:max-w-none">
        <HomeAllFeatures />
      </Page>
    </RoundedLayout>
  );
};

export const Route = createFileRoute("/home/all-features/")({
  component: AllFeaturesPage,
});
